import './Mask.scss';
import React from 'react';


export default class Mask extends React.Component{
    render() {
        return (
            <div className="m-mask" onClick={this.props.fClose}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/components/mask/Mask.jsx